import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from '../gql'

import type { TypeParams } from './types'

const DEFAULT_QUANTITY = 100

/** Assignable users API, listing the users of the current app. */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context
        ? gql.queries.users.executor({
            ...context,
            quantity: DEFAULT_QUANTITY,
          })
        : rxjs.of([]),
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([ec.models.Attribute.fromKey<TypeParams>('name', { name: 'Name' })])
}
